<template>
  <div class="home">
    <img class="bg-img" src="./home/image/page@2x.png">
    <a href="https://www.vipkid.com.cn/inforcertification" class="inforcertification"></a>
    <a href="https://www.vipkid.com.cn/businesslicensetwo" class="businesslicensetwo"></a>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'Home',
  components: {
  }
}
</script>

<style>
  html, body {
    margin: 0;
    padding: 0;
    font-size: 0;
  }
</style>

<style scoped>

  .home {
    width: 100%;
    position: relative;
  }

  .home .inforcertification {
    display: block;
    position: absolute;
    width: 5.555555%;
    height: 3.056%;
    background:rgba(255, 0, 0, 0.0);
    top: 94.9%;
    left: 27.31%;
  }

  .home .businesslicensetwo {
    display: block;
    position: absolute;
    width: 3.4%;
    height: 1.5%;
    background: rgba(255, 0, 0, 0.0);
    top: 96.7%;
    left: 67.91%;
  }

  .home .bg-img {
    width: 100%;
  }

</style>
